import {
  GET_PRE_LOGIN_FEATURES_DATA_RECEIVED,
  GET_PRE_LOGIN_FEATURES_ERROR,
  GET_POST_LOGIN_FEATURES_DATA_RECEIVED,
  GET_POST_LOGIN_FEATURES_ERROR
} from "../services/coreDataService";

const initialState = {};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_PRE_LOGIN_FEATURES_DATA_RECEIVED:
    case GET_POST_LOGIN_FEATURES_DATA_RECEIVED:
      return action.data;

    case GET_PRE_LOGIN_FEATURES_ERROR:
    case GET_POST_LOGIN_FEATURES_ERROR:
      return {
        ...state,
        err: action.err
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/featureFlags.js